var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inventory-item-actions" },
    [
      _c("c-button", {
        directives: [
          {
            name: "b-popover",
            rawName: "v-b-popover.hover.blur.top",
            value: "Редактировать",
            expression: "'Редактировать'",
            modifiers: { hover: true, blur: true, top: true },
          },
        ],
        staticClass: "inventory-item-actions__edit",
        attrs: { id: _vm.editButtonId, size: "iconic", icon: "edit" },
        on: { click: _vm.edit },
      }),
      _c("c-button", {
        staticClass: "inventory-item-actions__menu",
        attrs: {
          id: `inventory-item-actions-${_vm._uid}`,
          tabindex: "-1",
          size: "iconic",
          icon: "menu",
        },
      }),
      _c("dropdown-menu", {
        attrs: {
          target: `inventory-item-actions-${_vm._uid}`,
          list: _vm.actionsList,
        },
        on: { click: _vm.onActionClick },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }